import PBService from "@irati/utils/services"
import {TeamRegionMap, TeamState} from "@irati/types"
import {
  MutationBillingFindOrCreateUnitForRegionIdArgs,
  QueryBillingUnitsArgs,
  QueryBillingUnitForRegionIdArgs,
  QueryBillingZuoraSeatsCountArgs,
  ZuoraSeatsCount} from "@irati/types/ops"
import client, {MutationOptions, QueryOptions} from "@irati/utils/services/apollo"
import teamsService from "@irati/identity/services/teams"
import createForRegionMutation, {createForRegionKey} from "./mutations/createForRegion"
import billingUnitsQuery, {billingUnitsKey} from "./query/billingUnits"
import billingUnitForRegionQuery, {billingUnitForRegionKey} from "./query/billingUnitForRegion"
import billingSeatsCountQuery, {billingZuoraSeatsCountKey} from "./query/billingSeatsCount"

class BUService extends PBService {
  async list({businessId}: QueryBillingUnitsArgs, options: QueryOptions = {}): Promise<TeamRegionMap[]> {
    const variables = {businessId}
    return client.query({...options, query: billingUnitsQuery, variables}).then(({data}) => data[billingUnitsKey])
  }

  async getForRegionId({businessId, regionId}: QueryBillingUnitForRegionIdArgs, options: QueryOptions = {}): Promise<TeamRegionMap> {
    const variables = {businessId, regionId}
    return client.query({...options, query: billingUnitForRegionQuery, variables}).then(({data}) => data[billingUnitForRegionKey])
  }

  async getSeatsCount({businessId}: QueryBillingZuoraSeatsCountArgs, options: QueryOptions = {}): Promise<ZuoraSeatsCount> {
    const variables = {businessId}
    return client.query({...options, query: billingSeatsCountQuery, variables}).then(({data}) => data[billingZuoraSeatsCountKey])
  }

  async createForRegion(
    {businessId, regionId}: MutationBillingFindOrCreateUnitForRegionIdArgs,
    options: MutationOptions = {}
  ): Promise<TeamRegionMap> {
    const variables = {businessId, regionId}

    return client.mutate({...options, mutation: createForRegionMutation, variables}).then(({data}) => {
      const businessUnit = data[createForRegionKey]
      return teamsService.list(businessId, {state: TeamState.All}, {fetchPolicy: "network-only"}).then(() => businessUnit)
    })
  }
}

const buService = new BUService({errorHandlers: []})

export default buService
